import { Box, Modal, Stack } from "@mui/material";

const ModalTemplate = (props) => {
    const style = {
        maincontainer: {
            //position: 'relative',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: (props.width) ? props.width : '500px',
            '@media(max-width: 500px)': {
                width: '100%'
            },
            border: '1px solid',
            borderColor: 'boderColor.default',
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4
        },
        title: {
            fontSize: '21px',
            marginTop: '-15px',
            fontWeight: '700',
            textAlign: 'center',
            paddingBottom: '35px'
        }
    };
    if (props.height) {
        style.maincontainer.minHeight = props.height;
    }

    return (
        <>
            <Modal
                open={props.open}
                onClose={props.close}
                sx={{ overflowY: 'auto' }}
            >
                <Box sx={style.maincontainer}>
                    <Box sx={style.title}>
                        {props.title}
                    </Box>
                    <Box id='Container' sx={{ flexGrow: 1 }}>
                        {/* "props.children" is show container data in component <Mycomponent>container data</Mycomponent> */}
                        {props.children[0]}
                    </Box>
                    <Box id='Footer' sx={{ flexGrow: 1, paddingTop: '25px' }}>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-end"
                            spacing={1}
                        >
                            {props.children[1]}
                        </Stack>
                    </Box>
                </Box>
            </Modal >
        </>
    )
}

export default ModalTemplate